import "./AgileTeamTabPage.scss";

import { Text } from "@fluentui/react-northstar";
import { UserSubscriptionDTO } from "@teams/types/api";
import React from "react";
import { useParams } from "react-router";

import { useUserInfo } from "../../_shared/actions/useUserInfo";
import { Banner } from "../../_shared/components/Banner";
import { SubscribeButton } from "../../_shared/components/Checkout/SubscribeButton";
import { GenericSurveyTabPage } from "../../_shared/components/GenericSurveyTabPage";
import { ContentScope } from "../../survey/actions/useChannelSurveys";

export const AgileTeamTabPage: React.FC = () => {
  const { scope } = useParams<{ scope: ContentScope }>();
  const { user } = useUserInfo();

  const userSubscription = user?.subscriptions.find(sub => sub.plan === "agile-standup");

  return (
    <GenericSurveyTabPage
      loadingMessage="Loading Standups ..."
      scope={scope}
      showSchedules
      showSurveys
      pageName="team"
      noResultsContent={<NoSurveyGetStarted subscription={userSubscription} />}
      createBtnContent="Create Standup"
      headerContent={
        userSubscription?.state !== "active" ? (
          <SubscriptionEnded subscription={userSubscription} />
        ) : null
      }
    />
  );
};

type SubscriptionEndedParams = {
  subscription: UserSubscriptionDTO | undefined;
};

const SubscriptionEnded: React.FC<SubscriptionEndedParams> = ({ subscription }) => {
  return (
    <div className="agile-team-tab-page__no-sub-banner">
      <SubscribeButton trackingName="subscribe-subscriptionended-banner">
        <Banner
          icon="caution-icon"
          header="Purchase a subscription to continue using Standups"
          text={
            <Text>
              Your {subscription?.type === "trial" ? "trial" : "subscription"} has ended. Choose a
              payment option to continue your daily standups.
            </Text>
          }
        />
      </SubscribeButton>
    </div>
  );
};

type NoSurveyGetStartedParams = {
  subscription: UserSubscriptionDTO | undefined;
};
const NoSurveyGetStarted: React.FC<NoSurveyGetStartedParams> = ({ subscription }) => {
  return (
    <div className="agile-team-tab-page__missing-container">
      <Text
        className="agile-team-tab-page__no-survey"
        size="larger"
        weight="bold"
        as="div"
        align="center"
      >
        Welcome to AgilePolly!
      </Text>

      <Text
        className="agile-team-tab-page__no-survey"
        size="medium"
        as="div"
        align="center"
        content={
          <>
            There are no standups here yet, click on <b>Create a standup</b> to get started{" "}
            {!subscription && (
              <>
                on your <b>free trial</b>
              </>
            )}
            .
          </>
        }
      />
    </div>
  );
};
